import React, { useState } from "react";

const OrderInvoice = ({ orderId, amormedusatoken }) => {
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchInvoice = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_WorldofAmorURL}store/invoice/${orderId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${amormedusatoken}`,
              "x-publishable-api-key": "pk_064d6ed51a63a7bfc2a65accf14890e257ad4c48d03096432f0ec2b7fde86353"
          },
        }
      );
      const result = await response.json();
      setInvoiceData(result);
    } catch (err) {
      console.error("Invoice fetch error:", err);
      setError("Failed to load invoice.");
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    fetchInvoice();
  };

  return (
    <div>
      <button className="btn border fs-6"  onClick={handleClick} disabled={loading}>
        {loading ? "Loading..." : "Generate"}
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {invoiceData && invoiceData.invoice ? (
        <a className="btn border fs-6"
          href={invoiceData.invoice.file_path}
          target="_blank"
          rel="noopener noreferrer"
          download
        >
         Download
        </a>
      ) : (
        invoiceData && <small>Not Generated</small>
      )}
    </div>
  );
};

export default OrderInvoice;
